/* eslint-disable @typescript-eslint/no-explicit-any */
export function debounce<T extends (...args: any[]) => void>(
  fn: T,
  delay: number
): ((...args: Parameters<T>) => void) & { cancel: () => void } {
  let timeoutId: ReturnType<typeof setTimeout>;

  const debounced = (...args: Parameters<T>) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      fn(...args);
    }, delay);
  };

  debounced.cancel = () => {
    clearTimeout(timeoutId);
  };

  return debounced;
}

export function throttleFn<T extends unknown[], U>(
  fn: (...args: T) => U,
  limit: number
): ((...args: T) => void) & { cancel: () => void } {
  let lastCall = 0;
  const throttled = (...args: T) => {
    const now = Date.now();
    if (now - lastCall >= limit) {
      lastCall = now;
      fn(...args);
    }
  };

  throttled.cancel = () => {
    lastCall = 0;
  };

  return throttled;
}
